<template>
  <div
    ref="dropdown"
    class="HeaderDropdown outline  outline-1 outline-bg-inverse/10
    bg-bg-base min-w-224 py-8 shadow-lg transition-all duration-300 ease-out"
  >
    <div v-if="itemList.length > 0" class="type-xs text-text-subtle text-start my-8 px-16">
      {{ navHeading }}
    </div>
    <MyPageNavMobile
      v-for="item in itemList"
      :key="item.type"
      :item="item"
      :selected="''"
      :only-selected="false"
      @click.stop="(e) => click(item, e)"
    />
    <div v-if="secondItemList?.length" class="type-xs text-text-subtle text-start my-8 px-16">
      {{ $t('mypage.nav.cs') }}
    </div>
    <MyPageNavMobile
      v-for="item in secondItemList"
      :key="item.type"
      :item="item"
      :selected="''"
      :only-selected="false"
      @click.stop="(e) => click(item, e)"
    />
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import MyPageNavMobile from '~/components/account/MyPageNavMobile.vue';
import type { NavigationItem } from '~/composables/useMyPageNavigation';
import useMyPageNavigation from '~/composables/useMyPageNavigation';
import { useUserStore } from '~/store/user';

import useLinkReplacer from '~/composables/useLinkReplacer';
import { trackButtonClick } from '~/composables/useTracking';

const { $t } = useNuxtApp();
const userStore = useUserStore();

const { accountUrl, salesUrl } = useLinkReplacer();

const { itemList, secondItemList, setNavigationList } = useMyPageNavigation();

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const dropdown = ref<HTMLElement>();

onMounted(() => {
  setNavigationList();
});

const click = async(item: NavigationItem, uiEvent: UIEvent) => {
  if (item.function === 'link') {
    trackButtonClick(uiEvent, 'select_user_menu_item', item.type, $t(item.langKey));
    setShowPage(item.type, item.isSalesToolPage ?? false);
  }
  if (item.function === 'logout') {
    await userStore.logOut();
  }
  if (item.function === 'stopImpersonate') {
    await userStore.stopImpersonatingCompany();
    navigateTo(accountUrl('selectCustomer'));
  }
  emit('close');
};

const setShowPage = (page: string, isSalesToolPage: boolean) => {
  if (isSalesToolPage) {
    navigateTo(salesUrl(page));
  } else {
    navigateTo(accountUrl(page));
  }
};

const navHeading = computed(()=> {
  if (userStore.isCountryManagerUser) {
    return $t('header.countryManagerTools');
  }
  if (userStore.isSalesRepUser) {
    return $t('mypage.sales.headline');
  }

  let output = $t('mypage.headline');
  if (userStore.isCustomerSuccessUser || userStore.userProfile.impersonatingCompany) {
    output += ` (${userStore.userProfile?.company?.name})`;
  }
  return output;
});

onClickOutside(dropdown, () => {
  setTimeout(()=> {
    emit('close');
  }, 100);
});

</script>
